// extracted by mini-css-extract-plugin
export var backLink = "post-page-module--back-link--0vl+L";
export var page = "post-page-module--page--tNXJr";
export var title = "post-page-module--title--nW9VC";